// AboutPage.js

import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import MainLayout from "../Layouts/MainLayout";
import '../CSS/AboutPage.css'

const AboutPage = () => {
  return (
    <MainLayout>
      <HelmetProvider>
      <Helmet>
        <title>About BlogWiki - Curated News and Information</title>
        <meta
          name="description"
          content="Welcome to BlogWiki, your ultimate destination for curated news and information from around the world. Discover insightful articles and diverse perspectives on technology, entertainment, business, and lifestyle."
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "About BlogWiki",
              "description": "Welcome to BlogWiki, your ultimate destination for curated news and information from around the world. Discover insightful articles and diverse perspectives on technology, entertainment, business, and lifestyle.",
              "url": "https://www.yourwebsite.com/about",
              "mainEntity": {
                "@type": "Organization",
                "name": "BlogWiki",
                "url": "https://www.yourwebsite.com/",
                "sameAs": [
                  "https://www.facebook.com/YourBlogWiki",
                  "https://twitter.com/YourBlogWiki",
                  "https://www.linkedin.com/company/YourBlogWiki"
                ],
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.yourwebsite.com/src/Images/LogoTest.png",
                  "width": 600,
                  "height": 60
                },
                "description": "BlogWiki is a community-driven platform providing curated news and diverse perspectives on various topics."
              }
            }
          `}
        </script>
      </Helmet>
      </HelmetProvider>
      <div className="about-page">
        <h1>About BlogWiki</h1>
        <p>
          Welcome to BlogWiki, your ultimate destination for curated news and
          information from around the world. We're passionate about sharing
          interesting stories, insightful articles, and thought-provoking
          opinions with our readers.
        </p>
        <p>
          At BlogWiki, we believe that everyone deserves access to reliable
          news and diverse perspectives. Our mission is to provide a platform
          where you can discover and explore a wide range of topics, from
          technology and entertainment to business and lifestyle.
        </p>
        <p>
          Unlike traditional news outlets, we're not journalists. We're a
          community-driven platform where anyone can contribute their
          knowledge, expertise, and insights. Whether you're an enthusiast, a
          hobbyist, or a professional, we welcome you to join our community
          and share your voice.
        </p>
        <p>
          Our goal is to foster meaningful discussions, encourage critical
          thinking, and promote digital literacy. We value diversity,
          inclusion, and respectful dialogue. Together, let's explore the
          world of news, discover new ideas, and engage in constructive
          conversations.
        </p>
        <p>
          Thank you for being a part of BlogWiki. Your support and
          participation drive our platform forward. Join us on this journey
          as we strive to make the world of information more accessible,
          transparent, and empowering for all.
        </p>
        <p>Happy reading!</p>
      </div>
    </MainLayout>
  );
};

export default AboutPage;
